"use client";

// src/app/info/layout.jsx
import { useEffect, useMemo, useState } from "react";
import { usePathname } from "next/navigation";
import PrimaryTabs from "@/components/PrimaryTabs";
import { InfoOverviewContent, PrivacyContent, TermsContent } from "./InfoContent";
import HowToContent from "./HowToContent";

const INFO_TABS = [
  { key: "overview", label: "Overview", href: "/info" },
  { key: "how-to", label: "How To", href: "/info/how-to" },
  { key: "terms", label: "Terms", href: "/info/terms" },
  { key: "privacy", label: "Privacy", href: "/info/privacy" },
];

function tabKeyFromPath(pathname) {
  if (pathname === "/info/how-to") return "how-to";
  if (pathname === "/info/terms") return "terms";
  if (pathname === "/info/privacy") return "privacy";
  return "overview";
}

export default function InfoLayout() {
  const pathname = usePathname();
  const initialActive = tabKeyFromPath(pathname);
  const [active, setActive] = useState(initialActive);

  useEffect(() => {
    setActive(tabKeyFromPath(pathname));
  }, [pathname]);

  useEffect(() => {
    const handlePopState = () => {
      setActive(tabKeyFromPath(window.location.pathname));
    };
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  const activeContent = useMemo(() => {
    if (active === "how-to") return <HowToContent />;
    if (active === "terms") return <TermsContent />;
    if (active === "privacy") return <PrivacyContent />;
    return <InfoOverviewContent />;
  }, [active]);

  return (
    <main className="mx-auto max-w-5xl px-4 py-8">
      <h1 className="h1 mb-4">Info</h1>

      <div className="edge-mobile mb-6 border-b border-[var(--border)]">
        <PrimaryTabs
          tabs={INFO_TABS}
          active={active}
          onChange={(key) => {
            const next = INFO_TABS.find((tab) => tab.key === key);
            if (next?.href && next.key !== active) {
              setActive(next.key);
              window.history.pushState(window.history.state, "", next.href);
            }
          }}
        />
      </div>

      {activeContent}
    </main>
  );
}
